function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { useField, useFormikContext } from 'formik';
import GenericFormElement from '../GenericFormElement';
const FormRadioButtons = props => {
  const {
    name,
    label,
    onBlur,
    onChange,
    className,
    verticalSpacing,
    options,
    description,
    optionalLabel,
    isLabelHidden,
    isLiveValidationDisabled
  } = props;
  const [field, meta, helpers] = useField(name);
  const {
    submitCount
  } = useFormikContext();
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    name: name,
    label: label,
    meta: meta,
    helpers: helpers,
    className: className,
    verticalSpacing: verticalSpacing,
    fieldType: "radioGroup",
    visualValidation: false,
    description: description,
    optionalLabel: optionalLabel,
    isLabelHidden: isLabelHidden,
    submitCount: submitCount,
    isLiveValidationDisabled: isLiveValidationDisabled
  }, options.map(option => {
    const isChecked = field.value === option.key;
    return /*#__PURE__*/React.createElement("div", {
      className: "form-item",
      key: option.key
    }, /*#__PURE__*/React.createElement("input", _extends({}, field, {
      id: option.key,
      type: "radio",
      value: option.key,
      checked: isChecked
    }, props, {
      "aria-describedby": meta.touched && meta.error ? "".concat(name, "-error") : '',
      onBlur: e => {
        if (onBlur) onBlur(e);
        field.onBlur(e);
      },
      onChange: e => {
        if (onChange) onChange(e);
        field.onChange(e);
      }
    })), /*#__PURE__*/React.createElement("label", {
      htmlFor: option.key
    }, option.value));
  }));
};
export default FormRadioButtons;